import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EnergyDetails } from '../../../shared/constants';
import { GeneralService } from '../../../shared/services/general.service';

@Component({
  selector: 'app-energy-tab',
  templateUrl: './energy-tab.component.html',
  styleUrls: ['./energy-tab.component.scss']
})
export class EnergyTabComponent implements OnInit {
  EnergyDetails = EnergyDetails;
  @Input() defaultTab: string;
  @Input() gasMeterId: String;
  tab: string;

  @Output()
  change: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(private route: ActivatedRoute,
              private generalService: GeneralService) { }

  ngOnInit() {
    this.tab = this.defaultTab;
    this.route.queryParams.subscribe(values => {
      if (Object.keys(EnergyDetails).map(k => k.split('_').join(' ')).includes(values.energyType)) {
        this.tab = values.energyType;
        this.change.emit(values.energyType !== undefined);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/energy/energy-tab/energy-tab.component.ts